<div class="flex w-full">
    <router-outlet></router-outlet>
    <div class="to-top md:hidden z-80" (click)="scrollToTop()" [ngClass]="{ 'show-scrollTop': windowScrolled }">
        <!-- Subir -->
        <mat-icon class="cursor-pointer" svgIcon="heroicons_solid:arrow-circle-up"> </mat-icon>
    </div>
</div>
